"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSHSBankComponent = void 0;
const primarybank_component_1 = require("../primarybank.component");
class CSHSBankComponent extends primarybank_component_1.CSPrimaryBankComponent {
    ngOnInit() {
        this.getSavedBankAccount(true);
        this.getAccountDetails();
        this.getPaymentMethod();
    }
    // To get the saved bank details from
    getSavedBankAccount(recall) {
        this.loader = true;
        this.accountService.getPrimarySavedBankDetailsHS(recall).subscribe((data) => {
            this.loader = false;
            this.saveBankData = data;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getAccountDetails(cacheResponse) {
        this.loader = true;
        this.accountService.getAccountDetails(cacheResponse).subscribe((accountInfo) => {
            this.loader = false;
            this.accountType = accountInfo.accountType;
            this.loader = false;
            this.subscriptions = accountInfo.subscription;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    // To save the details from modal to page
    saveBankDetails() {
        this.edit = 'no';
        this.newBankDetails = this.bankDetails;
        this.submitNewBankDetails();
        this.clearPopup();
    }
    // Submit New bank account details
    submitNewBankDetails() {
        this.error = '';
        const content = {
            routingNumber: this.newBankDetails.bankAccount.routingNumber,
            accountNumber: this.newBankDetails.bankAccount.bankAccountNumber,
            defaultPaymentMethod: this.newBankDetails.setPrimaryPayment,
            bankName: this.newBankDetails.bankName,
            checkType: this.newBankDetails.bankCheckType
        };
        this.loader = true;
        this.accountService.saveBankDetailsHS(content).subscribe((res) => {
            this.getPaymentMethod();
            this.getSavedBankAccount();
            this.loader = false;
        }, (err) => {
            this.loader = false;
            this.error = err;
        });
    }
    // Delete new bank details
    deleteBankDetails() {
        this.error = '';
        this.showNewBankAcc = false;
        this.newBankDetails = '';
        this.loader = true;
        this.accountService.deleteSavedBankDetailsHS().subscribe((res) => {
            this.modalReference.close();
            this.getPaymentMethod();
            this.getSavedBankAccount();
        }, (err) => {
            this.loader = false;
            this.error = err;
            this.modalReference.close();
        });
    }
    getPaymentMethod() {
        this.loader = true;
        this.accountDetailService.getPaymentMethodInformation().subscribe((info) => {
            this.paymentDetails = info;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
}
exports.CSHSBankComponent = CSHSBankComponent;
//# sourceMappingURL=hsbank.component.js.map